if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        // MERCHANT EDIT: validate personalization text BEFORE the cart add.
        // The .personalization-block.active wrapper is toggled by product.card-picker.js.
        const personalizationTextWrapper = document.querySelector(
          ".personalization-block.active",
        );
        if (personalizationTextWrapper) {
          const personalizationInput = document.getElementById(
            "persoonlijke-tekst-op-kaartje",
          );
          if (
            personalizationInput &&
            personalizationInput.value.trim() === ""
          ) {
            this.handleErrorMessage(
              (window.donselaarStrings &&
                window.donselaarStrings.personalizationRequired) ||
                "Vul de persoonlijke tekst voor op het kaartje in!",
            );
            return;
          }
        }

        // MERCHANT EDIT: enforce 18+ checkbox in JS. The form has novalidate
        // (Sense default), so HTML5 `required` doesn't block submission on
        // real user clicks either. This is the only place the 18+ check is
        // actually enforced.
        const ageCheckbox = document.getElementById("ik-ben-18-jaar");
        if (ageCheckbox && !ageCheckbox.checked) {
          this.handleErrorMessage(
            (window.donselaarStrings && window.donselaarStrings.ageRequired) ||
              "Bevestig dat je 18 jaar of ouder bent om dit product te kunnen bestellen.",
          );
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        // MERCHANT EDIT: attach selected card name as a line-item property on the main product.
        const additionalProductsSelect = document.getElementById(
          "additional-products",
        );
        if (additionalProductsSelect) {
          const selectedOption =
            additionalProductsSelect.options[
              additionalProductsSelect.selectedIndex
            ];
          const additionalProductName =
            selectedOption.getAttribute("data-name");
          formData.append("properties[Kaartje]", additionalProductName);
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            // MERCHANT EDIT: if a wenskaart was chosen, add it as a separate line-item with the personalization text.
            // The second add returns a cart response with updated sections; we use THAT response for renderContents.
            // This block must run BEFORE the !this.cart redirect, otherwise the second add gets skipped on pages
            // without a cart-drawer/cart-notification.
            let cartUpdatePromise = Promise.resolve(response);
            if (
              additionalProductsSelect &&
              additionalProductsSelect.value !== "Nee"
            ) {
              const additionalProductId = additionalProductsSelect.value;
              const personalizationInput = document.getElementById(
                "persoonlijke-tekst-op-kaartje",
              );
              const personalizationText = personalizationInput
                ? personalizationInput.value
                : "";

              const additionalProductFormData = new FormData();
              additionalProductFormData.append("id", additionalProductId);
              additionalProductFormData.append(
                "properties[Persoonlijke tekst op kaartje]",
                personalizationText,
              );
              if (this.cart) {
                additionalProductFormData.append(
                  "sections",
                  this.cart.getSectionsToRender().map((section) => section.id),
                );
                additionalProductFormData.append(
                  "sections_url",
                  window.location.pathname,
                );
              }

              cartUpdatePromise = fetch(`${routes.cart_add_url}`, {
                ...config,
                body: additionalProductFormData,
              })
                .then((additionalResponse) => additionalResponse.json())
                .then((additionalResponse) => {
                  if (additionalResponse.status) {
                    this.handleErrorMessage(additionalResponse.description);
                    this.error = true;
                    return response;
                  }
                  return additionalResponse;
                });
            }

            return cartUpdatePromise.then((finalResponse) => {
              if (this.error) return;

              if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              const startMarker = CartPerformance.createStartingMarker(
                "add:wait-for-subscribers",
              );
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: finalResponse,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  "add:wait-for-subscribers",
                  startMarker,
                );
              });
              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure(
                        "add:paint-updated-sections",
                        () => {
                          this.cart.renderContents(finalResponse);
                        },
                      );
                    });
                  },
                  { once: true },
                );
                quickAddModal.hide(true);
              } else {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(finalResponse);
                });
              }
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
}
